<template>
  <div id="app" ref="app">
    <Header v-if="showHeader" ref="Header" />
    <div ref="Main" class="main-container">
      <transition name="fade">
        <router-view ref="routerContainer" />
      </transition>
    </div>
    <Footer
      v-if="showFooter"
      ref="Footer"
      :style="{
        position: positionType,
        bottom: 0,
        left: 0
      }"
    />
    <div class="cm">
      <div
        :style="{ display: showStyle ? 'flex' : 'none' }"
        class="info"
        @mouseover="showStyle = true"
        @mouseout="showStyle = false"
      >
        <div class="left-container">
          <div v-for="(item, index) in infoFont" :key="index" class="info-item">
            <div class="info-item-title">{{ item.title }}</div>
            <div class="info-item-content">{{ item.content }}</div>
          </div>
        </div>
        <div class="right-container">
          <div>微信公众号</div>
          <img
            v-if="showCmImg"
            :src="setting.weixin_code.value"
            alt="微信公众号"
          >
          <!-- <el-button
            type="warning"
            size="small"
            class="go-cm"
            @click="advisory"
          >开始咨询</el-button> -->
        </div>
      </div>
      <div v-if="!showStyle" class="font-before">
        <i class="el-icon-s-comment" @mouseover.stop="showStyle = true" />
        <span @mouseover.stop="showStyle = true">咨询</span>
        <el-backtop class="go-back">
          <span
            v-if="showGoBackFont"
            style="text-align: center; color: #fff; font-size: 14px;"
            @mouseout.stop="showGoBackFont = false"
          >回到顶部</span>
          <i
            v-else
            class="el-icon-top"
            @mouseover.stop="showGoBackFont = true"
          />
        </el-backtop>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/service'
import Footer from '@/view/common/footer.vue'
import Header from '@/view/common/header.vue'

export default {
  name: 'App',
  components: {
    Footer,
    Header
  },
  data() {
    return {
      infoFont: [
        {
          prop: 'telephone',
          title: '咨询电话',
          content: '400-0755-911'
        },
        {
          prop: 'telephone_time',
          title: '咨询电话工作时间',
          content: '每天：09:00-19:00'
        },
        {
          prop: 'customer_service',
          title: '在线客服',
          content: '线上医师咨询'
        }
      ],
      positionType: '',
      showApp: false,
      showStyle: false,
      showHeader: false,
      showFooter: false,
      showCmImg: false,
      showGoBackFont: false,
      setting: null
    }
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.name !== oldVal.name) {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.getHeightList()
        }, 550)
      })
    },
    showStyle(newVal) {
      if (!newVal) {
        document.documentElement.scrollTop =
          document.documentElement.scrollTop + 1
        document.documentElement.scrollTop =
          document.documentElement.scrollTop - 1
        document.body.scrollTop = document.body.scrollTop + 1
        document.body.scrollTop = document.body.scrollTop - 1
      }
    }
  },
  created() {
    const VERSION = '1.0.1'

    const savedVersion = localStorage.getItem('appVersion')

    if ((savedVersion && savedVersion !== VERSION) || !savedVersion) {
      // 清除 localStorage 中的缓存
      localStorage.clear()
      // 清除 sessionStorage 中的缓存
      sessionStorage.clear()
      // 刷新页面
      window.location.reload(true)
    }

    // 保存当前版本到 localStorage
    localStorage.setItem('appVersion', VERSION)

    API.getSystem().then(res => {
      this.$setLoc({ key: 'setting', value: res.data, json: 1 })
      window.document.title = res.data.name.value // 修改网站标题
      this.$store.commit('SET_SETTING', JSON.stringify(res.data))
      this.setting = this.$getLoc({ key: 'setting', json: 1 })

      this.infoFont.forEach(item => {
        if (this.setting[item.prop]) {
          item.content = this.setting[item.prop].value
        }
      })
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.href = this.setting.title_ico.value
      link.rel = 'shortcut icon'
      link.type = 'image/x-icon'
      document.getElementsByTagName('head')[0].appendChild(link)
      // this.showApp = true
      this.showHeader = true
      this.showFooter = true
      this.showCmImg = true
      this.setting = this.$getLoc({ key: 'setting', json: 1 })
    })
  },
  // beforeMount() {
  //   this.setting = this.$getLoc({ key: 'setting', json: 1 })
  // },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.getHeightList()
      }, 549)
    })
    window.addEventListener('resize', () => {
      this.getHeightList()
    })
    window.addEventListener('scroll', () => {
      this.getHeightList()
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getHeightList()
    })
    window.removeEventListener('scroll', () => {
      this.getHeightList()
    })
  },
  methods: {
    getHeightList() {
      if (this.$refs.Footer && this.$refs.Header && this.$refs.Main) {
        const footerHeight = Number(this.$refs.Footer.$el.clientHeight)
        const mainHeight = Number(this.$refs.Main.clientHeight)
        const scrollHeight =
          Number(document.documentElement.scrollHeight) ||
          Number(document.body.scrollHeight)
        if (footerHeight + mainHeight < scrollHeight) {
          // this.positionType = 'fixed'
          this.positionType = 'relative'
        } else {
          this.positionType = 'relative'
        }
      }
    },
    setPhoneSearchHeight(data) {
      this.$nextTick(() => {
        if (this.$refs.routerContainer) {
          this.$refs.routerContainer.setPhoneSearchHeight(data)
        } else {
          setTimeout(() => {
            this.$refs.routerContainer.setPhoneSearchHeight(data)
          }, 555)
        }
      })
    },
    advisory() {
      window.open(
        'http://wpa.qq.com/msgrd?V=1&uin=1992031601&Site=qq&menu=yes'
      )
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/comm.scss";
.cm {
  position: fixed;
  bottom: 30%;
  right: 0;
  z-index: 30;
  .font-before {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 10px;
    width: 35px;
    font-size: 15px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    color: #fff;
    background: #e5b735;
    cursor: pointer;
    > i {
      font-size: 30px;
    }
    /deep/ .el-backtop {
      position: relative !important;
      bottom: 0 !important;
      right: 0 !important;
      margin-top: 20px !important;
      padding-top: 10px !important;
      border-radius: 0 !important;
      border-top: 1px solid #fff !important;
      background: transparent !important;
      box-shadow: none !important;
      z-index: 50;
      transition: all 0.3s !important;
      > i {
        font-size: 30px !important;
        color: #fff !important;
      }
    }
  }
  .info {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 400px;
    padding: 30px;
    padding-right: 50px;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background: url("~@/assets/images/cmBg.png");
    background-size: 30px 30px;
    background-color: #f2ede7;
    z-index: -9;
    .left-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 50px;
      .info-item {
        margin-bottom: 20px;
        &:last-of-type {
          margin-bottom: 0;
        }
        .info-item-title {
          font-size: 22px;
          color: #bd9916;
          margin-bottom: 10px;
        }
        .info-item-content {
          font-size: 18px;
          color: #000;
        }
      }
    }
    .right-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 150px;
      > div {
        margin-bottom: 10px;
        font-size: 22px;
        color: #bd9916;
      }
      img {
        width: 100%;
        margin-bottom: 20px;
        border-radius: 3%;
      }
      .go-cm {
        width: 100%;
        font-size: 20px;
        color: #fff;
        background: #e5b735;
        border-color: #e5b735;
        border-radius: 10px;
      }
    }
  }
  @media screen and (max-width: 992px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue